"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = function _default(_ref) {
  var style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    style: style,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    d: "M5 8L5 11 6 11 11.0653686 11C12.9999999 11 13 9.925354 13 9.925354L13 8C13 8 14.2558941 8.003794 15 8 14.9945429 8.59986662 15 9.68049084 15 10.5161133 15 11.4216309 13.8757935 13 12.0297241 13L6 13 5 13 5 16C5 16 2.47793654 13.3344202 1 12 2.47542998 10.6598296 5 8 5 8zM11 8L11 5 10 5 4.93463141 5C3.00000006 5 3 6.074646 3 6.074646L3 8C3 8 1.74410594 7.996206 1 8 1.00545713 7.40013338 1.00000001 6.31950916 1 5.48388672.99999999 4.57836914 2.12420655 3 3.97027594 3L10 3 11 3 11 0C11 0 13.5220635 2.66557984 15 4 13.52457 5.34017043 11 8 11 8L11 8z"
  }));
};

exports["default"] = _default;